<template>
  <div class="dt-auth-header"></div>
</template>

<script>
import { AUTH_LOGOUT_URL, IS_DEV } from "@/config";

export default {
  data() {
    return {
      isMoreMenu: false,
      LANGUAGES: [
        {
          title: "English",
          key: "en",
        },
        {
          title: "Русский",
          key: "ru",
        },
        {
          title: "Ўзбек",
          key: "cyrl",
        },
        {
          title: "Uzbek",
          key: "uz",
        },
      ],
      account: "Кабинет поставщика",
    };
  },
  computed: {
    // LANGUAGES() {
    //   return LANGUAGES;
    // },
    currentLang() {
      return this.LANGUAGES.find((p) => p.key === this.$i18n.locale);
    },
  },
  methods: {
    logOut() {
      this.$store.commit("clearUserData");
      if (!IS_DEV) {
        window.location.href = AUTH_LOGOUT_URL;
      } else {
        this.$router.push({ name: "login" });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.new-toolbar {
  max-height: 128px;

  &__menu {
    &__block {
      padding: 0 !important;
      margin-bottom: -3px;
      display: flex;
      align-items: center;

      &__img {
        a {
          img {
            width: 50px;
          }
        }
      }
    }

    &__main-menu {
      &__open-close-icon {
        cursor: pointer;
        padding: 4px;
      }

      nav {
        a {
          font-size: 14px;
          line-height: 17px;
          color: #a2a5b9;
          font-weight: 550;
          padding-left: 12px;
          padding-right: 12px;
          text-decoration: none;

          &:hover {
            color: #2bbbde !important;
          }
        }
      }
    }
  }

  &__sub-menu {
    position: absolute;
    background: #303d4d;
    width: 100%;
    height: 100px;
    left: 0;
    padding-bottom: 8px;

    nav {
      padding-top: 8px;
      display: flex;
      align-items: center;
      max-width: 800px;
      margin: 0 auto;
      padding-left: 57px;

      a {
        font-size: 14px;
        line-height: 17px;
        color: #a2a5b9;
        font-weight: 550;
        padding-left: 12px;
        padding-right: 12px;
        padding-bottom: 16px;
        text-decoration: none;

        &:hover {
          color: #2bbbde !important;
        }
      }
    }
  }
}

.main-toolbar {
  position: fixed;
  z-index: 1000;
  height: 48px !important;
  width: 100%;
  left: 0;
  top: 0;
  background: #303d4d;
  color: #fff;
  padding: 0 20px;

  &__container {
    max-width: 1230px;
    width: 100%;
    margin: 0 auto;
  }

  &__logo {
    img {
      margin-top: 4px;
      width: 50px;
    }
  }

  &__language {
    border-right: 1px solid #48596d;
  }

  &__account {
    display: flex;
    align-items: center;
  }

  &__menu {
    &__item {
      list-style: none;

      a {
        text-decoration: none;
        font-weight: 700;
        font-size: 14px;
        line-height: 17px;
        color: #a2a5b9;

        &:hover {
          color: white;
        }
      }
    }
  }
}

.rotate-icon-true {
  transform: rotate(180deg) !important;
}

.rotate-icon-false {
  transform: rotate(0deg) !important;
}

.transition-effect {
  &-enter-active,
  &-leave-active {
    transition: all 0.2s;
  }

  &-enter-from,
  &-leave-to {
    opacity: 0;
    transform: translateY(30px);
  }
}
</style>
